import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { NotificationBar } from 'src/services/notification.service';
import { emsBadge } from 'src/models/emsModels';
import { environment } from 'src/environment';
import { ConfirmDialogDialog } from '../confirm-dialog/confirm-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-badge-registry',
  templateUrl: './badge-registry.component.html',
  styleUrl: './badge-registry.component.scss'
})
export class BadgeRegistryComponent {

  notificationBar: NotificationBar;
  workspaceID = "";
  displayedColumns: string[] = ['uid', 'type', 'number', 'date', 'delete'];
  badgeSource = new MatTableDataSource<emsBadge>;
  searchValue: string;
  badgesRegistryDBRef: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private title: Title, private location: Location, private snackBar: MatSnackBar, public dialog: MatDialog, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
  }    

  ngOnInit() {  
    this.workspaceID  = this.location.path().split("/")[1];
    this.title.setTitle("Badge Registry - EsportsMS");
    this.loadBadges();
  }

  ngOnDestroy() {
    if (this.badgesRegistryDBRef) {
      this.badgesRegistryDBRef.off('value');
    };
  }

  searchBadge(event: Event) {
    this.searchValue = (event.target as HTMLInputElement).value;
    this.badgeSource.filter = this.searchValue.trim().toLowerCase();
  }

  loadBadges() {
    this.badgesRegistryDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/registry');
    this.badgesRegistryDBRef.on('value', x => {
      var rawData = x.toJSON();
      if (rawData) { 
        var badges = Object.keys(rawData).map(key => ({
          uid: key,
          ...rawData[key],
          date: new Date(rawData[key]?.date??{})
        })) as emsBadge[];
        badges.sort((a, b) => b.date.getTime() - a.date.getTime());
        this.badgeSource = new MatTableDataSource(badges);
        this.badgeSource.sort = this.sort;
        this.badgeSource.paginator = this.paginator;
        if (this.searchValue != undefined) {
          this.badgeSource.filter = this.searchValue.trim().toLowerCase();
        }
      }
      else {
        this.badgeSource = new MatTableDataSource();
      }
    });
  }

  changeNumber(badgeUID: string, event: Event) {
    var newValue = (event.target as HTMLInputElement).value;
    this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/registry/' + badgeUID).update({
      number: newValue
    });
  }

  changeType(badgeUID: string, newType: string) {
    this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/registry/' + badgeUID).update({
      type: newType
    });
  }

  async removeBadge(badgeUID: string) {
    var dialogRef = this.dialog.open(ConfirmDialogDialog, {
      data: {
        actionType: "remove",
        message: "Are you sure you want to remove Bagde " + badgeUID + "?",
      }
    });
    return dialogRef.afterClosed().toPromise().then(async res => {
      if (res == true) {
        this.db.database.app.database(environment.emsDatabaseURL).ref('/badges/' + this.workspaceID + '/registry/' + badgeUID).remove().then( x => {
          this.notificationBar.show("Badge removed!");
        }, err => {
            this.notificationBar.showUnknownError();
        })
      }
    });
  }
}
